<template>
  <div class="content">
    <h2>{{ father }} | Notas</h2>
    <v-row>
      <v-col cols="12" class="center">
        <template v-if="loadingDataGrupos">
          <v-progress-circular
            :size="50"
            indeterminate
            color="purple"
          ></v-progress-circular>
        </template>
        <template v-if="!loadingDataGrupos && gruposNotas == ''"
          >No hay datos cargados o ha habido un error !!!</template
        >
        <template v-else-if="gruposNotas != ''">
          <div class="text-left pa-3 ma-3">
            <v-row>
              <v-col>
                <h2 class="title">Gupos de Notas</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">Nombre de Grupo</v-col>
              <v-col cols="2">Promediable</v-col>
              <v-col class="center">Fecha Inicio</v-col>
              <v-col class="center">Fecha Fin</v-col>
              <v-col cols="1">Estado</v-col>
              <v-col cols="1">Más</v-col>
            </v-row>
            <template v-for="(grupo, index) in gruposNotas">
              <template v-if="grupo.nombre_grupo != 'examenes'">
                <v-row :key="index" class="fila_grilla" align-center>
                  <v-col cols="2">{{ mayus(grupo.nombre_grupo) }}</v-col>
                  <v-col cols="2" align-center>
                    <v-switch
                      v-model="hideDetails[index]"
                      class="ma-2"
                      fill-height
                      @change="
                        cambiarEstadoPromediableGrupo(
                          grupo.idgrupo,
                          hideDetails[index]
                        )
                      "
                    ></v-switch>
                  </v-col>
                  <v-col xs3>
                    <datePicker
                      class="paddingRight25"
                      :label="'fecha_inicio'"
                      :fecha="grupo.fecha_inicio"
                      :idGrupo="grupo.idgrupo"
                      :seccion="'grupo'"
                      @datePicker:cambiarFechaGrupo="cambiarFechaGrupo"
                    />
                  </v-col>
                  <v-col xs3>
                    <datePicker
                      class="paddingRight25"
                      :label="'fecha_fin'"
                      :fecha="grupo.fecha_fin"
                      :idGrupo="grupo.idgrupo"
                      :seccion="'grupo'"
                      @datePicker:cambiarFechaGrupo="cambiarFechaGrupo"
                    />
                  </v-col>
                  <v-col cols="1" class="paddingLetft10">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          @click="
                            cambiarEstadoGrupo(
                              grupo.idgrupo,
                              grupo.estado_grupo
                            )
                          "
                          :class="[
                            grupo.estado_grupo == '1'
                              ? 'greenColor'
                              : 'redColor',
                          ]"
                          >{{
                            grupo.estado_grupo == "1"
                              ? "mdi-check-circle"
                              : "mdi-minus-circle"
                          }}</v-icon
                        >
                      </template>
                      <span>{{
                        grupo.estado_grupo == "1"
                          ? "Habilitado"
                          : "Deshabilitado"
                      }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-dots-vertical</v-icon>
                      </template>
                      <span>Ver Más</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <template v-for="(nota, nota_index) in grupo.notas">
                  <v-row
                    :key="nota_index + '_' + nota_index"
                    class="fila_grilla"
                    align-center
                  >
                    <v-col cols="2">Exámen {{ mayus(nota.nombre) }}</v-col>
                    <v-col></v-col>
                    <v-col cols="3">
                      <datePicker
                        class="paddingRight25"
                        :label="'fecha_inicio'"
                        :fecha="nota.fecha_inicio"
                        :idGrupo="nota.idnota"
                        :seccion="'nota'"
                        @datePicker:cambiarFechaGrupo="cambiarFechaGrupo"
                      />
                    </v-col>
                    <v-col cols="3">
                      <datePicker
                        class="paddingRight25"
                        :label="'fecha_fin'"
                        :fecha="nota.fecha_fin"
                        :idGrupo="nota.idnota"
                        :seccion="'nota'"
                        @datePicker:cambiarFechaGrupo="cambiarFechaGrupo"
                      />
                    </v-col>
                    <!--
                    <v-col xs1 class="paddingLetft10">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          @click="cambiarEstadoGrupo(grupo.idgrupo, grupo.estado_grupo)"
                          :class="[grupo.estado_grupo == '1'? 'greenColor' : 'redColor']"
                        >{{(grupo.estado_grupo =='1')? 'check_circle':'remove_circle'}}</v-icon>
                      </template>
                      <span>{{grupo.estado_grupo == '1'? 'Habilitado' : 'Deshabilitado'}}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col xs1>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click>more_vert</v-icon>
                      </template>
                      <span>Ver Más</span>
                    </v-tooltip>
                    </v-col>-->
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                  </v-row>
                </template>
              </template>
            </template>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import datePicker from "@/components/_config/datePicker";

export default {
  data() {
    return {
      gruposNotas: "",
      loadingDataGrupos: true,
      hideDetails: [],
    };
  },
  components: {
    datePicker,
    //alumno
  },
  props: ["father"],
  mounted: function () {
    this.obtenerGruposNotas();
    //console.log("switch: ", this.hideDetails);
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    recargar() {
      this.obtenerGruposNotas();
    },
    obtenerGruposNotas() {
      //console.log("obtenerGruposNotas");
      let resultado = API.enviar("get", "obtenerGruposNotas", "");
      //console.log(this.alumnos.length, this.dialogNuevoAlumno);
      resultado
        .then((result) => {
          if (result.data.msj == "ok") {
            this.gruposNotas = result.data.result;
            this.loadingDataGrupos = false;
            let gruposResult = result.data.result;

            for (const obj in gruposResult) {
              this.hideDetails[obj] =
                gruposResult[obj].promediable == "1" ? true : false;
            }
          }
        })
        .catch((error) => {
          console.log(
            "configNotas | methods | obtenerGruposNotas |  catch: -> ",
            error
          );
        })
        .finally(() => {
          //this.loadingDataAlumnos = false;
        });
    },
    cambiarEstadoGrupo(idGrupo, estadoGrupo) {
      //console.log("idgrupo: ", idGrupo, estadoGrupo);
      let param = "idGrupo=" + idGrupo + "&estadoGrupo=" + estadoGrupo;
      let resultadoEditar = API.enviar("get", "cambiarEstadoGrupo", param);

      resultadoEditar
        .then(() => {
          //console.log("cambiarEstadoGrupo OK");
          this.obtenerGruposNotas();
        })
        .catch((error) => {
          console.log("Catch 1 cambiarEstadoGrupo !!!", error);
        });
    },
    cambiarEstadoPromediableGrupo(idGrupo, estadoPromediableGrupo) {
      //console.log(idGrupo, estadoPromediableGrupo);
      let param =
        "idGrupo=" +
        idGrupo +
        "&estadoPromediableGrupo=" +
        estadoPromediableGrupo;
      let resultadoEditar = API.enviar(
        "get",
        "cambiarEstadoPromediableGrupo",
        param
      );

      resultadoEditar
        .then(() => {
          //console.log("cambiarEstadoGrupo OK");
          this.obtenerGruposNotas();
        })
        .catch((error) => {
          console.log("Catch 1 cambiarEstadoGrupo !!!", error);
        });
    },
    cambiarFechaGrupo: function (label, nuevaFecha, idGrupo, seccion) {
      console.log("cambiarFechaGrupo: " + seccion);
      let param =
        "idGrupo=" +
        idGrupo +
        "&nuevaFecha=" +
        nuevaFecha +
        "&fechaParaCambiar=" +
        label +
        "&seccion=" +
        seccion;
      let resultadoEditar = API.enviar("get", "cambiarFechaGrupo", param);

      resultadoEditar
        .then(() => {
          //console.log("cambiarFechaGrupo OK");
          this.obtenerGruposNotas();
        })
        .catch((error) => {
          console.log("Catch 1 cambiarFechaGrupo !!!", error);
        });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  padding-bottom: 20px;
}

.title {
  padding-top: 20px;
  padding-left: 10px;
  background-color: #ccc;
  opacity: 0.8;
}
.paddingLetft10 {
  padding-left: 10px;
}
.paddingRight25 {
  padding-right: 25px;
}
.greenColor {
  color: green;
}
.redColor {
  color: red;
}
.v-icon {
  cursor: pointer;
}

.fila_grilla {
  border-bottom: solid 1px #ccc;
}

.center {
  text-align: center;
}
</style>